<div class="site-container grid center-loader">
    <div class="col-6 main-content">
        <ng-content></ng-content>
    </div>
    <div class="col-6 register-image">
        <img src="assets/images/registration-photo.png">
    </div>
</div>